import { Module } from 'vuex'
import actions from '@/modules/common/store/entityActions'
import mutations from '@/modules/common/store/entityMutations'
import getters from '@/modules/common/store/entityGetters'
import RootState from '@/store/rootState'
import EntityState from '@/modules/common/store/entityState'
import EntityService from '@/modules/common/services/entityService'
import InvoiceResource from '@/modules/invoice/services/invoiceResource'
import Invoice from '@/modules/invoice/domain/invoice'

const entityService = new EntityService<Invoice>(InvoiceResource, Invoice)
const invoiceModule: Module<EntityState<Invoice>, RootState> = {
  namespaced: true,
  state: new EntityState(),
  mutations,
  getters,
  actions: actions(entityService, 'invoice')
}

export default invoiceModule
